import React, { useEffect, useState } from 'react'
import './style.css'
import MenteesDataGrid from './MenteesDataGrid';
import axios from "axios"
import { FailedToast } from './toast';

const AssignMentees = ({ selectedSemester, selectedMentor, setSelectedMentor, selectedSemesterTemp, currentDept }) => {
    const [loading, setLoading] = useState(false);
    const [found, setFound] = useState(true);
    useEffect(() => {
        if (selectedSemester && !selectedMentor && currentDept !== 'FC') {
            setLoading(true);
            axios.get(`${process.env.REACT_APP_BACKEND_PORT}/assign?dept=${(currentDept === 'Computer Science' || currentDept === 'Software Engineering' || currentDept === 'Computer Arts') ? 'FC' : currentDept}&subDept=${(currentDept === 'Computer Science' || currentDept === 'Software Engineering' || currentDept === 'Computer Arts') ? currentDept : ''}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': "application/json"
                }
            }).then((res) => {
                setLoading(false);
                setFound(res.data.data.length === 0 ? false : true)
                setMentorList(res.data.data);
            }).catch(err => {
                setLoading(false)
                FailedToast(err.response.data.message)
            })
        } else if (selectedSemester && selectedMentor) {
            const data = selectedMentor.assignedStudents?.map((Item) => {
                return { sapID: Item.sapID, Department: Item.department, id: Item.sapID };
            });
            setStudentList(data);
        } else {
            setFound(true);
            setLoading(false);
            setSelectedMentor(false);
        }
    }, [selectedSemester, selectedMentor, currentDept])

    const [mentorList, setMentorList] = useState([]);

    const [studentList, setStudentList] = useState([]);

    return (
        <>
            {
                selectedSemester ? (<div className="mentor-list-container">
                    {
                        selectedMentor ? (<MenteesDataGrid data={studentList} setStudentList={setStudentList} selectedMentor={selectedMentor} setSelectedMentor={setSelectedMentor} />
                        ) : (<>
                            <h1 style={{ textAlign: "center", fontSize: "22px" }}>Mentor's List</h1>
                            <hr style={{ width: "100px", margin: "4px auto 30px auto", padding: "1px" }} />
                            <div>
                                <h1 style={{ textAlign: "center", fontSize: "18px", marginBottom: "10px" }}>Semester: {selectedSemesterTemp}</h1>
                            </div>
                            <div className="mentor-list">
                                {mentorList?.map((mentor, index) => (
                                    <div onClick={() => { setSelectedMentor(mentor) }} style={{ cursor: "pointer", border: "2px solid #15375c", transition: "transform 300ms ease-in-out 0s" }} key={index} className="mentor-card hover:scale-110">
                                        <h2>SAP ID: {mentor.sapID}</h2>
                                        <p>Students Assigned: {mentor.assignedStudents.length}</p>
                                    </div>
                                ))}
                            </div>
                        </>)
                    }
                </div>) : (<>
                    <div className='flex flex-col justify-center items-center' style={{ height: '50vh' }}>
                        <h1 style={{ fontWeight: 'bold', fontSize: '23px', textAlign: 'center', lineHeight: '3.5rem' }}>Please Select the Desired Department and Semester.</h1>
                    </div>
                </>)
            }
            {loading && <div className='flex flex-col justify-center items-center' style={{ height: '50vh' }}>
                <h1 style={{ fontWeight: 'bold', fontSize: '23px', textAlign: 'center', lineHeight: '3.5rem' }}>Loading...</h1>
            </div>}

            {!found && <div className='flex flex-col justify-center items-center' style={{ height: '50vh' }}>
                <h1 style={{ fontWeight: 'bold', fontSize: '23px', textAlign: 'center', lineHeight: '3.5rem' }}>No Mentor Found</h1>
            </div>}
        </>
    )
}

export default AssignMentees